// extracted by mini-css-extract-plugin
export default {"resultsBox":"ResultsBox_resultsBox__yCz8r","searchCheckbox":"ResultsBox_searchCheckbox__V6Lcu"};